// extracted by mini-css-extract-plugin
module.exports = {"social-media":"SocialMedia_social-media__31Xwy","link":"SocialMedia_link__3rK5V","icon":"SocialMedia_icon__2p68O"};